const today = new Date();

const uglySweatersDateRanges = [
  {
    start: {
      month: 10,
      day: 8,
      hour: 22,
    },
    end: {
      month: 10,
      day: 10,
      hour: 22,
    },
  },
  {
    start: {
      month: 10,
      day: 12,
      hour: 22,
    },
    end: {
      month: 10,
      day: 13,
      hour: 22,
    },
  },
];

export const showSweaters = uglySweatersDateRanges.some(({ start, end }) => {
  const startDate = new Date(
    Date.UTC(today.getUTCFullYear(), start.month, start.day, start.hour)
  );
  const endDate = new Date(
    Date.UTC(today.getUTCFullYear(), end.month, end.day, end.hour)
  );

  return (
    startDate.getTime() < today.getTime() && endDate.getTime() > today.getTime()
  );
});
